<template>
    <v-dialog v-model="$store.state.Parkland.StmtRange" fullscreen>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    Parkland Payments by Date Range
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.Parkland.StmtRange = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container>
                <v-row justify="end">
                    <v-btn
                        color="red"
                        dark
                        small
                        class="float-right mt-3 mr-3"
                        @click="getPdf"
                    >
                        Download
                        <v-icon class="ml-2">mdi-file-pdf-box</v-icon>
                    </v-btn>
                    <v-btn
                        color="success"
                        small
                        class="float-right mt-3"
                        @click="downloadExcel"
                    >
                        Download
                        <v-icon class="ml-2">mdi-microsoft-excel</v-icon>
                    </v-btn>
                </v-row>
                <v-data-iterator :items="Summary" :items-per-page="1">
                    <template v-slot:default="props">
                        <div v-for="(row, idx) in props.items" v-bind:key="'rows' + idx">
                            <v-data-table :headers="headersSummary" :items="row.Payments" :search="search" dense height="150px">
                                <template v-slot:top>
                                    <v-row>
                                        <v-col>
                                            <h4 class="my-auto">{{ row.TitleRow  }}</h4> 
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot="body.append">
                                    
                                    <tr>
                                        <td colspan="3" class="font-weight-bold text-right pr-5" style="font-size:14px;">Totals</td>

                                        <td class="font-weight-bold text-left" style="font-size:14px;">{{ row.total_upt }}</td>
                                        <td class="font-weight-bold text-left" style="font-size:14px;">{{ row.total_SumOfSunBOLTotal }}</td>
                                        <td class="font-weight-bold text-left" style="font-size:14px;">{{ row.total_parkland }}</td>
                                        <td class="font-weight-bold text-left" style="font-size:14px;">{{ row.total_fsc }}</td>
                                        <td class="font-weight-bold text-left" style="font-size:14px;">{{ row.total_diff }}</td>
                                    </tr>
                                
                                </template>
                            </v-data-table>
                        </div>
                    </template>
                </v-data-iterator>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['parms'],
    data: function () {
        return {
            headersSummary: [
                { text: 'FileName', value: 'FileName' },
                { text: 'Clearing', value: 'Clearing' },
                { text: 'Invoice Total', value: 'InvoiceTotal' },
                { text: 'TotalUPT', value: 'TotalUPT' },
                { text: 'SumOfSunBOLTotal', value: 'SumOfSunBOLTotal' },
                { text: 'PmtTOT', value: 'PmtTOT' },
                { text: 'FSCPmt', value: 'FSCPmt' },
                { text: 'Diff', value: 'Diff' },
            ],
            Summary: [],
            Totals: {
                TotalNetAmount: null,
                TotalInvoiceNumber: null,
                TotalDiff: null,
            },
            search: '',
            docs: '',
            Payment: [],
        };
    },

    mounted() {
        console.log(this.parms);
        this.getMatchs();
    },
    methods: {
        getMatchs: function () {
            var str = this.$store;
            str.state.isLoading = true;
            this.parms.Export = false;
            this.parms.Pdf = false;
            axios
                .post('conciliation/parkland/summary-gpr', this.parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.Summary = response.data;
                    this.Summary.forEach(x =>{
                        x.Payments = JSON.parse(x.Payments);
                    })
                    console.log(this.Summary);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'You do not have the permission to use this function.'
                        });
                    };
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });

                    }
                    str.state.isLoading = false;
                });
        },
        getPdf: function () {
            var str = this.$store;
            str.state.isLoading = true;
            this.parms.Pdf = true;
            this.parms.Export = false;
            this.parms.Title = "Parkland Payments by Invoice Summary";
            axios
                .post('conciliation/parkland/summary-gpr', this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Parkland Payments by Date Range.pdf');
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'You do not have the permission to use this function.'
                        });
                    };
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });

                    }
                    str.state.isLoading = false;
                });
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        downloadExcel: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.parms.Export = true;
            this.parms.Pdf = false;
            axios
                .post('conciliation/parkland/summary-gpr', this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute('download', 'Statement Summary Report By Range.xlsx');

                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
